import type { Rule, PunishmentStep } from '../types';
import { apiClient } from './client';

interface CreateRuleRequest {
  name: string;
  content: string;
  punishments: PunishmentStep[];
}

interface UpdateRuleRequest {
  content: string;
  punishments: PunishmentStep[];
}

export const rulesApi = {
  getRules: async (guildId: string): Promise<Rule[]> => {
    const response = await apiClient.get<Rule[]>(`/guilds/${guildId}/rules`);
    return response.data;
  },

  createRule: async (guildId: string, data: CreateRuleRequest): Promise<Rule> => {
    const response = await apiClient.post<Rule>(`/guilds/${guildId}/rules`, data);
    return response.data;
  },

  updateRule: async (guildId: string, ruleName: string, data: UpdateRuleRequest): Promise<Rule> => {
    const response = await apiClient.put<Rule>(`/guilds/${guildId}/rules/${ruleName}`, data);
    return response.data;
  },

  deleteRule: async (guildId: string, ruleName: string): Promise<void> => {
    await apiClient.delete(`/guilds/${guildId}/rules/${ruleName}`);
  },
};
